export const isIthClient = () => !!window.CefSharp;

export const openUrlSC = (url: string) => {
  if (!url || !isIthClient()) return;
  window.CefSharp.BindObjectAsync("JsObj").then(() => {
    window.JsObj && window.JsObj.showUrl(url);
  });
};

export const onIthAnchorClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
  if (isIthClient()) {
    e.preventDefault();
    const url = e.currentTarget.href;
    openUrlSC(url);
  }
};

export const ithOpenUrl = (url: string, target = '_blank') => {
  if (isIthClient()) {
    openUrlSC(url);
    return;
  }
  window.open(url, target);
};

export const ithOpenAIAgent = () => {
  if (!isIthClient()) return;
  window.CefSharp.BindObjectAsync("JsObj").then(() => {
    window.JsObj && window.JsObj.startSigmaAgents();
  });
};